import { render, staticRenderFns } from "./HistoricoTCGrafica.vue?vue&type=template&id=1994dd28&scoped=true&"
import script from "./HistoricoTCGrafica.vue?vue&type=script&lang=js&"
export * from "./HistoricoTCGrafica.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoTCGrafica.vue?vue&type=style&index=0&id=1994dd28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1994dd28",
  null
  
)

export default component.exports